import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import noop from 'utils/noop';
import { colors, spacing } from 'ui/theme';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { CriteriaCombinatorSelect, QueryCombinatorSelect } from '../CombinatorSelect';

import {
  CombinatorWrapper as CriteriaCombinatorWrapper,
  CriteriaHeader,
  CriteriaWrapper,
  RequirementsWrapper,
} from '../CriteriaLayout/CriteriaLayout.styles';
import { CombinatorWrapper, MainWrapper, TextWrapper } from '../QueryLayout/QueryLayout.styles';

export const testIds = {
  loadingState: 'query-builder-loading-state',
};
const LoadingConditionWraper = styled.div`
    display: flex;
    gap: ${spacing.half};
    padding: ${spacing.half};
  `;

const GrayedTextWrapper = styled(TextWrapper)`
    color: ${colors.textDisabled}
  `;

const SkeletonRow = (
  <LoadingConditionWraper>
    <Skeleton height={32} width={144} />
    <Skeleton height={32} width={64} />
    <Skeleton height={32} width={210} />
  </LoadingConditionWraper>
);

const criteriaLayout = (
  <CriteriaWrapper>
    <CriteriaHeader data-hasmargin>
      <CriteriaCombinatorWrapper>
        <CriteriaCombinatorSelect
          onChange={noop}
          isDisabled
          value={null}
          hasError={false}
          placeholder=""
        />
      </CriteriaCombinatorWrapper>
    </CriteriaHeader>
    <RequirementsWrapper>{SkeletonRow}</RequirementsWrapper>
  </CriteriaWrapper>
);
// Create the query layout with the criteria
export const LoadingState = () => {
  const { t } = useTranslation();
  return (
    <MainWrapper data-test={testIds.loadingState}>
      <CombinatorWrapper>
        <GrayedTextWrapper>{t('storybook.layouts.query.preText')}</GrayedTextWrapper>
        <QueryCombinatorSelect
          onChange={noop}
          isDisabled
          value={null}
          hasError={false}
          placeholder=""
        />
        <GrayedTextWrapper>{t('storybook.layouts.query.postText')}</GrayedTextWrapper>
      </CombinatorWrapper>
      {criteriaLayout}
    </MainWrapper>
  );
};
